import http from "./http";

export function list(code) {
  return http.get(`appCodes/getCodesByParam?code=${code}`);
}
